import { useEffect, useState, useRef } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { Loader2, Check, XCircle } from "lucide-react";

export default function BookingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [bookingId, setBookingId] = useState(null);
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("failed"); return; }
    const poll = async () => {
      attempts.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setBookingId(r.data.booking_id);
        if (r.data.payment_status === "paid") { setState("paid"); return; }
        if (r.data.status === "expired") { setState("failed"); return; }
      } catch {}
      if (attempts.current >= 6) { setState("failed"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="booking-success-page">
      <div className="text-center max-w-md">
        {state === "checking" && (<>
          <Loader2 className="w-10 h-10 text-rr-gold animate-spin mx-auto" strokeWidth={1} />
          <h1 className="font-heading text-4xl mt-6 text-rr-ivory">Confirming your payment</h1>
          <p className="text-rr-muted mt-2">A moment while we secure your reservation…</p>
        </>)}
        {state === "paid" && (<>
          <div className="w-16 h-16 rounded-full bg-rr-gold/15 flex items-center justify-center mx-auto"><Check className="w-8 h-8 text-rr-gold" strokeWidth={1.4} /></div>
          <h1 className="font-heading text-5xl mt-6 text-rr-ivory">It's confirmed</h1>
          <p className="text-rr-muted mt-3 leading-relaxed">Your sanctuary is reserved. Your concierge will now enrich your itinerary with arrival details as your dates approach.</p>
          <button onClick={() => navigate(bookingId ? `/trips/${bookingId}` : "/trips")} data-testid="view-trip-btn" className="btn-gold px-8 py-3.5 mt-8 text-xs uppercase">View My Journey</button>
        </>)}
        {state === "failed" && (<>
          <div className="w-16 h-16 rounded-full bg-rr-surface flex items-center justify-center mx-auto"><XCircle className="w-8 h-8 text-rr-muted" strokeWidth={1.4} /></div>
          <h1 className="font-heading text-4xl mt-6 text-rr-ivory">Payment not confirmed</h1>
          <p className="text-rr-muted mt-2">We couldn't verify the payment. You can try again from your journey.</p>
          <Link to={bookingId ? `/trips/${bookingId}` : "/trips"} className="btn-outline inline-flex px-8 py-3.5 mt-8 text-xs uppercase">Back to My Journey</Link>
        </>)}
      </div>
    </div>
  );
}
